import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import "./App.css";
import Router from "./routes/Router";
import { fetchAndStoreMandateSession } from "./util/fetchAndStoreMandate";
import { MANDATE_STALE_MS } from "./util/mandateSessionStorage";

const App = () => {
  const dispatch = useDispatch();
  const refreshTimerRef = useRef(null);

  useEffect(() => {
    const clearRefreshTimer = () => {
      if (refreshTimerRef.current != null) {
        clearTimeout(refreshTimerRef.current);
        refreshTimerRef.current = null;
      }
    };

    const scheduleNextFullMandateFetch = () => {
      clearRefreshTimer();
      refreshTimerRef.current = window.setTimeout(() => {
        fetchAndStoreMandate();
      }, MANDATE_STALE_MS);
    };

    const fetchAndStoreMandate = async () => {
      clearRefreshTimer();
      try {
        await fetchAndStoreMandateSession(
          dispatch,
          localStorage.getItem("role"),
        );
      } catch (err) {
        console.error(err);
      } finally {
        scheduleNextFullMandateFetch();
      }
    };

    fetchAndStoreMandate();

    return () => clearRefreshTimer();
  }, [dispatch]);

  return <Router />;
};

export default App;
